<div class="modal-header">
	<h4 class="modal-title">{{ 'editAdditionalOrderInformation.preview.title.schematicPreview' | translate }}</h4>
	<button type="button" class="close" data-dismiss="modal" aria-label="Close" (click)="close()">
		<cfe-icon [iconName]="'close'"></cfe-icon>
	</button>
</div>
<div class="modal-body text-left">
	<cfe-input-textarea
		[placeholder]="'editAdditionalOrderInformation.preview.text.instructionsOfDentist' | translate"
		[label]="'editAdditionalOrderInformation.preview.title.instructionsDentist' | translate"
		[id]="'text-area-instruct'"
		[disabled]="false"
		[notMarkAsRequired]="false"
	>
	</cfe-input-textarea>
	<ng-container *ngFor="let viewModel of getViewModels(); let idx = index">
		<div ng *ngIf="viewModel.template.isActivated">
			<ng-container *ngIf="viewModel.template.type === 'DROPDOWN'">
				<cfe-input-select
					[id]="'dropdown-' + idx"
					[options]="viewModel.dropDownOptions"
					[tabIndex]="idx + 1"
					[disabled]="false"
					[placeholder]="''"
					[control]="viewModel.formGroup.get('previewValue')"
					[label]="viewModel.template.name"
					[notMarkAsRequired]="!viewModel.originalFormGroupValue.isMandatory"
				>
				</cfe-input-select>
			</ng-container>
			<ng-container *ngIf="viewModel.template.type === 'YES_NO'">
				<cfe-input-radio-wrapper
					[groupHeading]="viewModel.template.name"
					[control]="viewModel.formGroup.get('previewValue')"
					[notMarkAsRequired]="!viewModel.originalFormGroupValue.isMandatory"
				>
					<cfe-input-radio
						[value]="'yes'"
						[label]="'editAdditionalOrderInformation.preview.label.yes' | translate"
						[control]="viewModel.formGroup.get('previewValue')"
						[id]="'yes-radio-' + idx"
						[name]="'radio-group-' + idx"
					>
					</cfe-input-radio>
					<cfe-input-radio
						[value]="'no'"
						[label]="'editAdditionalOrderInformation.preview.label.no' | translate"
						[control]="viewModel.formGroup.get('previewValue')"
						[id]="'no-radio-' + idx"
						[name]="'radio-group-' + idx"
					>
					</cfe-input-radio>
				</cfe-input-radio-wrapper>
			</ng-container>
			<ng-container *ngIf="viewModel.template.type === 'TEXT'">
				<cfe-input-textarea
					[control]="viewModel.formGroup.get('previewValue')"
					[label]="viewModel.template.name"
					[id]="'text-area-' + idx"
					[rows]="viewModel.template.possibleValues"
					[tabIndex]="idx + 1"
					[disabled]="false"
					[notMarkAsRequired]="!viewModel.originalFormGroupValue.isMandatory"
				>
				</cfe-input-textarea>
			</ng-container>
		</div>
	</ng-container>
	<div>
		<cfe-input-date
			[id]="'searchReturnDate'"
			[label]="'editAdditionalOrderInformation.preview.title.returnDate' | translate"
			[tabIndex]="4"
			[disabled]="false"
			[notMarkAsRequired]="false"
		>
		</cfe-input-date>
	</div>
	<h4 class="text-secondary text-center">{{ 'editAdditionalOrderInformation.preview.title.returnTime' | translate }}</h4>
	<div>
		<cfe-input-time></cfe-input-time>
	</div>
</div>
<div class="modal-footer"></div>
